import { useRef, useState } from 'react';
import './Login.css';
import { getAuth, signInWithCustomToken } from "firebase/auth";
import { getFunctions, httpsCallable } from "firebase/functions";
import monogram from './images/monogram-blue.svg';

export function LoginForm({isSubmitting, onSubmit, error, formRef}) {
  return (
    <>
      {error && (
        <div className="error-message" role="alert" style={{ color: 'red', marginBottom: '1em' }}>
          {error}
        </div>
      )}
      <form id="loginForm" ref={formRef} onSubmit={onSubmit} aria-busy={isSubmitting} aria-label="Guest login form">
        <div className="input-group">
          <span className="input-icon">👤</span>
          <input type="text" id="first-name" name="firstName" placeholder="First name" required autoComplete="given-name" disabled={isSubmitting} />
        </div>
        
        <div className="input-group">
          <span className="input-icon">🫂</span>
          <input type="text" id="last-name" name="lastName" placeholder="Family name" required autoComplete="family-name" disabled={isSubmitting} />
        </div>
        
        <button type="submit" disabled={isSubmitting}>
          {isSubmitting ? 'Signing you in...' : 'Enter'}
        </button>
      </form>

      {isSubmitting && (
        <p className="info-text" role="status" aria-live="polite">
          Signing you in. This can take a moment.
        </p>
      )}
    </>
  );
}

function Login() {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [loginError, setLoginError] = useState(null);
  const formRef = useRef(null);
  const functions = getFunctions();
  const helloWorld = httpsCallable(functions, 'helloWorld');

  async function login(formData) {
    setIsSubmitting(true);
    setLoginError(null);
    const firstName = formData.get("firstName")?.trim();
    const lastName = formData.get("lastName")?.trim();
    // Check for legacy credentials
    if (firstName?.toLowerCase() === "wedding" && lastName === "190926") {
      setLoginError("Guest access has changed—please enter your name to continue.");
      setIsSubmitting(false);
      formRef.current?.reset();
      return;
    }
    try {
      // call this Cloud Function using Firebase SDK:
      const response = await helloWorld({
        firstName,
        lastName
      });

      const authToken = response.data;
      const credential = await signInWithCustomToken(getAuth(), authToken);
      console.log("successfully logged in user", credential.user);
    } catch (error) {
      setLoginError("Login failed. Please check your details and try again.");
      formRef.current?.reset();
    } finally {
      setIsSubmitting(false);
    }
  }

  async function handleSubmit(event) {
    event.preventDefault();
    await login(new FormData(event.currentTarget));
  }

  return (
    <div className="login">
      <div className="container">
        <img className="monogram" src={monogram} alt="" />

        <p className="subtitle">Please sign in to view our wedding details</p>

        <LoginForm isSubmitting={isSubmitting} onSubmit={handleSubmit} error={loginError} formRef={formRef} />
      </div>
    </div>
  );
}

export default Login;
